import React, { Component } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { Button, Glyphicon } from 'react-bootstrap'
import { handleErrorFetchingData } from '../../../../functions/errorHandling'
import getServerURL from '../../../../functions/getServerURL'

class ExportFunctionalGroup extends Component {

  state = {
    downloadingFunctionalGroup: false,
  }


  handleExportAssignmentMetrics = () => {
    if (this.state.downloadingFunctionalGroup) {
      return
    }

    const { functionalGroup } = this.props

    this.setState({ downloadingFunctionalGroup: true })

    axios({
      url: `${getServerURL()}export-functional-group-users/`,
      method: 'GET',
      params: {
        'functional_group_id': functionalGroup.id
      },
      headers: {
        'Authorization': "Bearer " + localStorage.getItem("token")
      },
      responseType: 'blob',
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const date = new Date().toJSON().split("T")[0].split('-')
      const formattedDate = `${date[1]}-${date[2]}-${date[0]}`
      link.setAttribute('download', `${functionalGroup.name}_Users_${formattedDate}.xlsx`)
      this.setState({ downloadingFunctionalGroup: false })
      swal({
        title: "Your file is ready",
        text: "Click the button to download",
        icon: "success",
        button: 'Download'
      })
      .then(() => {
        document.body.appendChild(link)
        link.click()
      })
    })
    .catch(error => {
      const message = "There was an error downloading your file."
      handleErrorFetchingData(error, message)
    })
  }

  render () {

    const { downloadingFunctionalGroup } = this.state

    return (
      <Button
        disabled={downloadingFunctionalGroup}
        onClick={this.handleExportAssignmentMetrics}
      >
        {downloadingFunctionalGroup ?
          <Glyphicon
            glyph='refresh'
            style={{minWidth: '170px'}}
            className='rotate-btn'
          />
          :
          'Export Group Users to Excel'
        }
      </Button>
    )
  }
}

export default ExportFunctionalGroup



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/FunctionalGroupContainer/ExportFunctionalGroup.js